import _ from "lodash";

import GPie from "../../Graphs/GPie";
import GraphTitle from "../../Graphs/GraphTitle";
import "./PieChartDistribution.scss";
import { VStack } from "Components/LabIZO/Stackizo";
import { IGPTQADashboardState } from "../../Dashboard";

interface PieChartDistributionProps {
  width: string;
  title: string;
  data: { name: string; value: number }[];
  className: string;
  take?: number; // taking the top X names
}

const PieChartDistribution: React.FC<PieChartDistributionProps> = ({ width, title, data, className, take }) => {
  let sortedData = _.sortBy(data, (o) => -o.value);
  if (take) {
    sortedData = sortedData.slice(0, take);
  }

  return (
    <VStack className={className} width={width}>
      <GraphTitle title={title || ""} />
      <GPie data={sortedData} />
    </VStack>
  );
};

export default PieChartDistribution;
